import BaseTemplate from './baseTemplate'
import Permission from '@/models/permission'

export default class PermissionTemplate extends BaseTemplate<Permission> {
  public value: string = ''
  public get text(): string {
    return this.item.code_name
  }
  public get id(): number {
    return this.item.id
  }
  public get protected(): boolean {
    return this.item.protected
  }
  public get category(): string {
    return this.item.category
  }

  constructor(permission: Permission, value: string = '') {
    super(permission)
    if (value) {
      this.value = value
    } else {
      this.value = permission.code_name
    }
  }
}
